export const humanizeStateChoice = (state: string): string => {
  return state.replace(/_/g, ' ');
};
